/**
 * Copyright ©2022 Drivepoint
 */

import React from "react";
import {
  AdminPanelSettingsOutlined, AirplaneTicketOutlined,
  AssessmentOutlined, LayersOutlined, Settings,
  MonetizationOnOutlined, ElectricalServicesOutlined,
  SpeedOutlined, InventoryOutlined, StackedBarChartOutlined,
  AccountTreeOutlined, LineAxisOutlined, PersonOutline,
  Lock, Group, Warning, Info, PeopleOutlined, Star
} from "@mui/icons-material";

const AnalyticsInfoPage = React.lazy(() => import("../pages/info/AnalyticsInfoPage/AnalyticsInfoPage"));
const ChartSandboxPage = React.lazy(() => import("../pages/ChartSandboxPage/ChartSandboxPage"));
const CompanySettingsPage = React.lazy(() => import("../pages/CompanySettingsPage/CompanySettingsPage"));
const DashboardsInfoPage = React.lazy(() => import("../pages/info/DashboardsInfoPage/DashboardsInfoPage"));
const DataStudioPage = React.lazy(() => import("../pages/DataStudioPage"));
const DazzlerEditPage = React.lazy(() => import("../dazzler/components/DazzlerEditPage/DazzlerEditPage"));
const DazzlerPage = React.lazy(() => import("../dazzler/components/DazzlerPage/DazzlerPage"));
const ExternalLinkPage = React.lazy(() => import("../pages/ExternalLinkPage"));
const FinanceInfoPage = React.lazy(() => import("../pages/info/FinanceInfoPage"));
const FirebaseActionPage = React.lazy(() => import("../pages/user/FirebaseActionPage"));
const ForgotPasswordPage = React.lazy(() => import("../pages/user/ForgotPasswordPage"));
const InfoPage = React.lazy(() => import("../pages/info/InfoPage"));
const IntuitDisconnectPage = React.lazy(() => import("../pages/intuit/IntuitDisconnectPage"));
const IntuitPage = React.lazy(() => import("../pages/intuit/IntuitPage"));
const InviteCompanyPage = React.lazy(() => import("../pages/administration/InviteCompanyPage"));
const InviteUserPage = React.lazy(() => import("../pages/user/InviteUserPage/InviteUserPage"));
const InviteUsersPage = React.lazy(() => import("../pages/administration/InviteUsersPage/InviteUsersPage"));
const LandingPage = React.lazy(() => import("../pages/LandingPage"));
const ManageCompaniesPage = React.lazy(() => import("../pages/administration/ManageCompaniesPage"));
const ManageUsersPage = React.lazy(() => import("../pages/administration/ManageUsersPage"));
const PlansPage = React.lazy(() => import("../pages/Plans/PlansPage/PlansPage"));
const PlanDetailPage = React.lazy(() => import("../pages/Plans/PlanDetailPage/PlanDetailPage"));
const PresencePage = React.lazy(() => import("../pages/administration/PresencePage/PresencePage"));
const QuickstartWelcomePage = React.lazy(() => import("../pages/quickstart/QuickstartWelcomePage/QuickstartWelcomePage"));
const ReportsPage = React.lazy(() => import("../pages/ReportsPage/ReportsPage"));
const ScorecardPage = React.lazy(() => import("../pages/ScorecardPage/ScorecardPage"));
const ScorecardsPage = React.lazy(() => import("../pages/ScorecardsPage/ScorecardsPage"));
const SettingsPage = React.lazy(() => import("../pages/SettingsPage/SettingsPage"));
const SignInPage = React.lazy(() => import("../pages/user/SignInPage/SignInPage"));
const SignUpPage = React.lazy(() => import("../pages/user/SignUpPage"));
const SourcesPage = React.lazy(() => import("../pages/SourcesPage/SourcesPage"));
const TeamPage = React.lazy(() => import("../pages/TeamPage/TeamPage"));
const UserDetailPage = React.lazy(() => import("../pages/TeamPage/UserDetailPage/UserDetailPage"));

export default class ComponentRegistry {

  static classForName(name: string): any {
    switch (name) {
      case "AdminPanelSettingsOutlined": return AdminPanelSettingsOutlined;
      case "AirplaneTicketOutlined": return AirplaneTicketOutlined;
      case "AnalyticsInfoPage": return AnalyticsInfoPage;
      case "AssessmentOutlined": return AssessmentOutlined;
      case "ChartSandboxPage": return ChartSandboxPage;
      case "CompanySettingsPage": return CompanySettingsPage;
      case "DashboardsInfoPage": return DashboardsInfoPage;
      case "DataStudioPage": return DataStudioPage;
      case "DazzlerEditPage": return DazzlerEditPage;
      case "DazzlerPage": return DazzlerPage;
      case "ElectricalServicesOutlined": return ElectricalServicesOutlined;
      case "ExternalLinkPage": return ExternalLinkPage;
      case "FinanceInfoPage": return FinanceInfoPage;
      case "FirebaseActionPage": return FirebaseActionPage;
      case "ForgotPasswordPage": return ForgotPasswordPage;
      case "Group": return Group;
      case "Info": return Info;
      case "InfoPage": return InfoPage;
      case "IntuitDisconnectPage": return IntuitDisconnectPage;
      case "IntuitPage": return IntuitPage;
      case "InventoryOutlined": return InventoryOutlined;
      case "InviteCompanyPage": return InviteCompanyPage;
      case "InviteUserPage": return InviteUserPage;
      case "InviteUsersPage": return InviteUsersPage;
      case "LandingPage": return LandingPage;
      case "LayersOutlined": return LayersOutlined;
      case "LineAxisOutlined": return LineAxisOutlined;
      case "Lock": return Lock;
      case "MonetizationOnOutlined": return MonetizationOnOutlined;
      case "AccountTreeOutlined": return AccountTreeOutlined;
      case "ManageCompaniesPage": return ManageCompaniesPage;
      case "ManageUsersPage": return ManageUsersPage;
      case "PersonOutline": return PersonOutline;
      case "PresencePage": return PresencePage;
      case "QuickstartWelcomePage": return QuickstartWelcomePage;
      case "ReportsPage": return ReportsPage;
      case "PeopleOutlined": return PeopleOutlined;
      case "PlansPage": return PlansPage;
      case "PlanDetailPage": return PlanDetailPage;
      case "ScorecardPage": return ScorecardPage;
      case "ScorecardsPage": return ScorecardsPage;
      case "Settings": return Settings;
      case "SettingsPage": return SettingsPage;
      case "SignInPage": return SignInPage;
      case "SignUpPage": return SignUpPage;
      case "SourcesPage": return SourcesPage;
      case "SpeedOutlined": return SpeedOutlined;
      case "StackedBarChartOutlined": return StackedBarChartOutlined;
      case "Star": return Star;
      case "TeamPage": return TeamPage;
      case "UserDetailPage": return UserDetailPage;
      case "Warning": return Warning;
      default: throw new Error(`unknown component class name: ${name}`);
    }
  }

}
